import axios from "axios";
import {API_URL} from "../environment";

if (localStorage.getItem("ip")) {
    let id = localStorage.getItem("ip")
    if(id && id.country_code)
    axios.defaults.headers.common["CountryId"] = id.country_code;
        ;
}

export default class HttpService {
    static setToken = (id) => {
        axios.defaults.headers.common["CountryId"] = id;
    };

    static get = (url, params) => axios.get(`${API_URL}/${url}`, {params});

    static post = (url, data) => axios.post(`${API_URL}/${url}`, data);

    static put = (url, data, params) => axios.put(`${API_URL}/${url}`, data, {params});

    static delete = (url, params) => axios.delete(`${API_URL}/${url}`, {params});

    static gets = (url, params) => axios.get(`${API_URL}/${url}`, {params});

    static addressget = (params) => axios.get(`https://api.ideal-postcodes.co.uk/v1/autocomplete/addresses?api_key=${process.env.REACT_APP_IDEAL_POSTCODES_KEY}&query=${params}`);
}
